import { AnimationStateToggleButton } from './AnimationStateToggleButton';
import { ActionStateToggleButtonProps } from './types';
import { useAnimationState } from './useAnimationState';

export type AnimationStateToggleButtonWrapperProps = Pick<ActionStateToggleButtonProps, 'className'>;

export function AnimationStateToggleButtonWrapper(props: AnimationStateToggleButtonWrapperProps) {
  const { currentState, toggle } = useAnimationState();

  return <AnimationStateToggleButton {...props} currentActionState={currentState} onClick={toggle} />;
}
